@if (isVisible) {
  <div class="rs_skip rsbtn rs_preserve" [id]="idButtonDom">
    <a rel="nofollow" class="rsbtn_play" [title]="'read-speaker.listen-with-me' | wording" [href]="urlReadSpeaker">
      <span class="rsbtn_right rsimg rsplay rspart"></span>
    </a>
  </div>
}
